import { formatDateString } from "@/v2-common/utils/utils.date"
import cn from "@/v2-ui/utils/utils.cn"
import Switch from "@/v2-ui/switch"
import Badge from "@/v2-backoffice-client/components/badge"
import type { FeatureFlag } from "@/v2-backoffice-client/featureFlags/featureFlags.mock"

export type FeatureFlagCardProps = {
  flag: FeatureFlag
  onToggle(id: string, enabled: boolean): void
}

const SCOPE_VARIANTS = {
  global: "neutral",
  tenant: "outline",
  user: "outline",
} as const

function FeatureFlagCard(props: FeatureFlagCardProps) {
  const { flag, onToggle } = props

  return (
    <div
      className={cn(
        "feature-flag-card",
        !flag.isEnabled && "feature-flag-card-is-disabled",
      )}
    >
      <div className="feature-flag-info">
        <div className="feature-flag-header">
          <span className="feature-flag-name">{flag.name}</span>
          <Badge variant={SCOPE_VARIANTS[flag.scope]} size="sm">
            {flag.scope}
          </Badge>
        </div>
        <p className="feature-flag-description">{flag.description}</p>
        <div className="feature-flag-meta">
          <span>ID: {flag.id}</span>
          <span>Updated: {formatDateString(flag.updatedAt)}</span>
          <span>By: {flag.updatedBy}</span>
        </div>
      </div>

      <Switch
        checked={flag.isEnabled}
        onCheckedChange={(checked) => onToggle(flag.id, checked)}
      />
    </div>
  )
}

export default FeatureFlagCard
